<div class="pie-chart align-self-sm-center">
    <div class="row h-100" *ngIf="chartItems">
        <div class="pie-container col mt-6 pl-5">
            <div class="pie-background"></div>
            <div *ngFor="let item of chartItems; index as i">
                <div [ngStyle]="{'transform':'rotate('+ item.PieChartDegree + 'deg)'}" class="hold">
                    <div [ngStyle]="{'transform':'rotate('+item.GraphValue+'deg)'}" class="pie" [ngClass]="getPieChartColor(i)"></div>
                </div>
                <!--a repeated rotation as the rotation won't work with >180 degree-->
                <div *ngIf="item.Repeat" [ngStyle]="{'transform' : 'rotate('+(item.GraphValue + item.PieChartDegree - 5)+'deg)'}" class="hold">
                    <div [ngStyle]="{'transform':'rotate('+(item.GraphValue + 5)+'deg)'}" class="pie" [ngClass]="getPieChartColor(i)"></div>
                </div>
            </div>
        </div>

        <div class="col align-self-center">
            <div class="row"  *ngFor="let item of chartItems; index as i">
                <div class="col-2" >
                    <span class="li-before" [ngClass]="getPieChartColor(i)"></span>
                </div>
                <div class="col-10">
                    <span class="float-left">{{item.Title}}</span> <span class=" ml-2 float-left">{{item.ChartValue}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
